import {SCREEN_SIZE} from 'src/app/core/constants/screen-size';
import {MatDialog} from '@angular/material/dialog';
import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild, ViewChildren} from '@angular/core';
import {MatSort, Sort} from '@angular/material/sort';
import {DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, merge, Observable, ReplaySubject, Subject, Subscription} from 'rxjs';
import {NotificationService} from 'src/app/core/services/notification.service';
import {CommonService} from 'src/app/core/services/common.service';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {Message} from 'src/app/core/class/message';
import {finalize, takeUntil, tap} from 'rxjs/operators';
import {ViewPdfComponent} from 'src/app/shared/components/view-pdf/view-pdf.component';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {ToastrService} from 'ngx-toastr';
import {CdkDetailRowDirective} from 'src/app/shared/directive/cdk-detail-row.directive';
import {DocumentTypeService} from 'src/app/core/services/document-type.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DocumentService} from 'src/app/core/services/document.service';
import {SignDocumentComponent} from '../sign-document/sign-document.component';
import {SignDocumentListComponent} from '../sign-document/sign-document-list/sign-document-list.component';
import {SignProgressComponent} from '../sign-document/sign-progress/sign-progress.component';
import {FormControl, NgForm} from '@angular/forms';
import {MatSelect} from '@angular/material';
import {ResponsiveService} from '../../../../../../core/services/responsive.service';
import {EnumColumnTable, EnumContractUserStatus, EnumSignMethod} from 'src/app/core/constants/contract';
import {SignProgressCloudCaComponent} from '../sign-document/sign-progress-cloud-ca/sign-progress-cloud-ca.component';
import {ErrorCode} from '../../../../../../core/constants/error-code';
import {SignProgressUsbTokenComponent} from '../sign-document/sign-progress-usb-token/sign-progress-usb-token.component';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {SignDocumentService} from 'src/app/core/services/sign-document.service';
import {WarningComponent} from '../../../../../../shared/components/warning/warning.component';
import {NotifyWarningComponent} from '../../../../../../shared/components/notify-warning/notify-warning.component';
import {NotifyWarningCustomComponent} from '../../../../../../shared/components/notify-warning-custom/notify-warning-custom.component';
import {MultiDownloadService} from '../../../../../../core/services/multi-download.service';
import {EnumDownloadMenuName} from '../../../../../../core/constants/common';
import {PermissionConfig} from 'src/app/core/constants/permission-config';
import { ContractService } from 'src/app/core/services/contract.service';
import { WarningDataAuthenticationComponent} from 'src/app/shared/components/warning-data-authentication/warning-data-authentication.component';
import { SignAuthenticationPopupComponent } from '../add-document-moha/sign-aunthentication-popup/sign-aunthentication-popup.component';
import { DowloadAppVContractComponent } from '../../../../../../shared/components/dowload-app-vcontract-vneid/dowload-app-vcontract-vneid.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';
import { RequestConfirmIdentityComponent } from 'src/app/shared/components/request-confirm-identity/request-confirm-identity.component';
import { EnterIdentityVneidComponent } from 'src/app/shared/components/enter-identity-vneid/enter-identity-vneid.component';

declare function initPluginCertificate(comp: any, contracts: any): any;

declare function signHashNormal(comp: any, base64Hash: any, sessionId: any, serialNumber: any): any;


@Component({
  selector: 'app-search-document-sign-digital',
  templateUrl: './search-document-sign-digital.component.html',
  styleUrls: ['./search-document-sign-digital.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({height: '0px', minHeight: '0', visibility: 'hidden'})),
      state('*', style({height: '*', visibility: 'visible'})),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class SearchDocumentSignDigitalComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * interval of calling.
   */
  private static DISPLAY_FINISH_SIGN_PROGRESS_TIMEOUT = 10000;

  @BlockUI() blockUI: NgBlockUI;
  /**
   * Percent of processing.
   */
  public processedPercent = 0;

  /**
   * length of document.
   */
  public documentCount = 0;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  public PermissionConfig = PermissionConfig;
  public userType: number = Number(localStorage.getItem('userType'));
  private sessionId = null;
  private isDisableNextButton = false;
  private sign: any = {};
  private contractsForSign: any;
  private digitalCertificateDetailId: any;
  private signTransactionId: any;
  private digitalCertificateId: any;
  private serialNumberChoose: any;
  private signedContract: Array<string> = [];

  // private cancelCalls: Array<Promise<any>> = [];

  setCertRawdata(value) {
    this.sign.certRawdata = value;
  }

  setSerialNumber(value) {
    this.sign.serialNumber = value;
  }

  setIssuedTo(value) {
    this.sign.issuedTo = value;
  }

  setDistinguishedName(value) {
    this.sign.distinguishedName = value;
  }

  setTaxCode(value) {
    this.sign.taxCode = value;
  }

  setIssuedBy(value) {
    this.sign.issuedBy = value;
  }


  setActiveDate(value) {
    this.sign.activeDate = new Date(value);
  }

  setExpireDate(value) {
    this.sign.expireDate = new Date(value);
  }

  setActiveContinueButton() {
    this.isDisableNextButton = false;
  }

  user = {
    tenantId: localStorage.getItem('tenantId'),
    userName: '',
    fullName: '',
    userType: 2,
    enterpriseId: localStorage.getItem('enterpriseId'),
    phone: '',
    email: '',
    description: '',
    permissions: []
  };

  documentTypeEnterprise = {
    documentTypeId: 0,
    name: '',
    parentId: null,
    serviceTypeId: null
  };

  serviceTypes: { id: string, name: '' }[];

  // displayedColumns: string[] = [
  //   'check',
  //   'STT',
  //   'contractName',
  //   'allName',
  //   'createdUser',
  //   'receivedTime',
  //   'symbol'
  // ];

  displayedColumns: string[] = [];

  columnDefinitions = [
    {def: 'check', default: true, showMD: true, showMobile: true, name: '', check: true},
    {def: 'STT', default: true, showMD: true, showMobile: true, name: '', check: true},
    {def: 'uuidContractMoha',default: true, showMD: true, showMobile: true, name: '', check: true},
    {def: 'contractName', default: true, showMD: true, showMobile: true, name: '', check: true},
    {def: 'allName', default: true , showMD: true, showMobile: false, name: 'headertable.contract_parties', check: true},
    {def: 'allEmail', default: true, showMD: true, showMobile: false, name: 'headertable.contract_parties_email', check: true},
    {def: 'status', default: true, showMD: true, showMobile: false, name: 'form.status_process', check: true},
    {def: 'createdUser', default: true, showMD: true, showMobile: false, name: 'enterprise_contract.table_headers.forward_by', check: true},
    {def: 'receivedTime', default: true , showMD: true, showMobile: false, name: 'headertable.received_time', check: true},
    {def: 'createdBy', default: false , showXS: false, showSM: false, showMD: true, name: 'enterprise_contract.table_headers.created_by', check: false},
    //{def: 'statusOther', default: false , showXS: false, showSM: false, showMD: true, name: 'headertable.other_signing_parties_status', check: false},
    {def: 'expiredDate', default: false , showXS: false, showSM: true, showMD: true, name: 'enterprise-certificate_management.lbl_end_date', check: false},
    {def: 'action', default: true , showMD: true, showMobile: true, name: '', check: true},
  ];
  isCheckedAllColumn: boolean = false;
  tableWidth = 950;
  enumColumnTable = EnumColumnTable;
  contractUserStatus = EnumContractUserStatus;
  isNotAttestedUser: boolean = false;
  documents = new Document();
  enumContractUserStatus = EnumContractUserStatus;
  checkAll: boolean;
  goFrom: string;
  isConfirmVNeID : any;

  dataSource: DocumentDataSource;
  childDataSourceList: DocumentDataSourceKeyPair = {};
  dataSelected: any[] = [];

  paginate: Paginate;
  childPaginateList: PaginateKeyPair = {};

  oldData = this.documents;
  childOldDataList: DocumentKeyPair = {};

  isFirstLoad = true;
  childIsFirstLoadList: BooleanKeyPair = {};

  childIsExpanding: Array<string>;


  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('myForm', {static: false}) ngForm: NgForm;
  @ViewChild('documentTypeSelect', {static: false}) wardSelect: MatSelect;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('statusSelect', {static: false}) statusSelect: MatSelect;
  @ViewChild('serviceTypeSelect', {static: false}) serviceTypeSelect: MatSelect;

  childSortList: SortKeyPair = {};

  sortDirection = 'ASC';
  childSortDirection: StringKeyPair = {};

  sortColumn = 'name';
  sortChildColumn: StringKeyPair = {};

  dialogRef: any;
  dialogSign: any;
  dialogProgress: any;

  checkFocus = true;
  error = '';
  subscription: Subscription;
  expanded = [];
  openedRow: CdkDetailRowDirective;
  parentDocuments: Document[];
  signLotImage: Boolean;
  fileUpload: File;
  imageBase64: any;
  isBasicSearchForm = true;
  isSigningLotUsb: Boolean = true;

  userCancel: Boolean = false;
  expiredBatch: Boolean = false;

  // List all parent branches
  //parentBranches: { id: string, name: '' }[];
  // Selected model value for autocomplete
  selectedBranch: { id: string, name: '' };
  // List all parent branches
  documentTypeByBranch: comboBox[] = [];
  serviceTypeByEnterprise: comboBox[] = [];

  documentTypeByBranchFilterCtrl: FormControl = new FormControl();
  serviceTypeByEnterpriseFilterCtrl: FormControl = new FormControl();

  public filteredDocumentTypeByBranch: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredServiceTypeByEnterprise: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  private _onDestroy = new Subject<void>();

  /**
   * signing flag background.
   */
  public isSigning = false;

  public hasTransSavedCloudCA = false;

  /**
   * signed percent.
   */
  public signedPercent = 30;

  // Number of checked documents
  public countCheck: number = 0;
  public countContract: number = 0;

  @Input() singleChildRowDetail: boolean;

  receivedDateErr: string = '';
  waitSignDocsCount = 0;
  isExpansionDetailRow = (index, row) => row.hasOwnProperty('detailRow');

  signStatus: any;
  dataStateUrl: any;
  dataCheckVneid = {
    typeVerify: '',
    certificateNoCCCD: '',
    timeWaitShare: 60
  }
  constructor(
    private documentTypeService: DocumentTypeService,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private responsiveService: ResponsiveService,
    private signDocumentService: SignDocumentService,
    private downloadService: MultiDownloadService,
    private contractService: ContractService,
    public deviceService: DeviceDetectorService,
    private documentMohaService: DocumentMohaService,

  ) {
    super(commonService, message);
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.dataStateUrl = this.router.getCurrentNavigation().extras.state;
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  getServiceTypeByEnterprise() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    this.commonService.getEnterpriseServiceType(enterpriseId).subscribe(rs => {
      if (rs && rs.data) {
        const filteredData = rs.data.filter(item => item.isEmploymentContract === true);
        this.serviceTypeByEnterprise = filteredData;
        this.filteredServiceTypeByEnterprise.next(filteredData.slice());
        this.documents.type = parseInt(this.documents.type);
      }
    });
  }

  ngOnInit() {
    this.getColumnByUser();
    // this.isSigningLotUsb = true;
    this.serviceTypeByEnterpriseFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.commonService.filterCertificateType(this.serviceTypeByEnterprise
          , this.serviceTypeByEnterpriseFilterCtrl, this.filteredServiceTypeByEnterprise);
      });

    this.getServiceTypeByEnterprise();
    this.documentService.signUpdateAction.subscribe((result) => {
      // console.log("result vao ne isStopSignLot: " + JSON.stringify(result.isStopSignSlot ? result.isStopSignSlot : "null"));
      // console.log(result)
      if (!result || !result.res) {
        this.isSigning = false;
        this.isSigningLotUsb = false;
        return;
      }
      this.isSigningLotUsb = !result.isStopSignSlot;
      const rs = result.res;
      // if (this.expiredBatch) {
      // 	this.expiredBatch = false;
      // }
      // console.log("phan hoi ne: " + JSON.stringify(result));

      if (result.expired) {
        this.isSigningLotUsb = false;
        this.userCancel = true;
        this.expiredBatch = true;
        // this.documentService.stopSign().subscribe();
        // return ;
      }
      rs.data && rs.data.info && rs.data.info.details && rs.data.info.details.forEach(ct => {
        if (ct.status === DocumentService.STATUS_DONE) {
          const index = this.dataSelected.findIndex(data => data.id === ct.contractId);
          if (index !== -1) {
            this.dataSelected.splice(index, 1);
          }
        }
      });

      this.signedContract.forEach(el => {
        const index = this.dataSelected.findIndex(data => data.id === el);
        if (index !== -1) {
          this.dataSelected.splice(index, 1);
        }
      });

      this.signStatus = result.signStatus;
      const percent = result.percent;
      const isStopSignSlot = result.isStopSignSlot;

      if (isStopSignSlot) {
        this.isSigning = false;
      } else {
        this.isSigning = true;
      }

      if (rs && rs.data) {
        if (!rs.data.info || !rs.data.info.details || rs.data.info.details.length === 0) {
          return;
        }

        // set value of progress.
        this.documentCount = rs.data.info.details.length;

        // update progress of signed document.
        this.processedPercent = percent;
      }

      // Check there're signing before.
      if (this.signStatus === DocumentService.SLOT_SIGN_FINISH) {
        if (this.typeCertificate === EnumSignMethod.CLOUD_CA) {
          // do work here
          if (this.dialogRef.componentInstance == null || this.dialogRef.componentInstance.isDisabledStopSignButton == false) {
            if (rs.data.info.success != false) {
              this.dialogRef.close();
              this.dialog.open(NotifyWarningComponent, {
                // data: "Lô ký duyệt của bạn đã xác nhận ký trên ứng dụng Ký số từ xa, hệ thống sẽ tiếp thực hiện các bước để xử lý hợp đồng  và sẽ gửi lại thông báo sau khi hoàn thành. Bạn có thể chọn lô tiếp theo để thực hiện phê duyệt."
                data: this.message.getMessage('messages.sign_batch_mysign_complete'),
              });
              this.dataSelected = [];
            }
          }
        }
        setTimeout(() => {
          this.signStatus = null;
          this.isSigning = false;
          this.isSigningLotUsb = false;

          // reload page when finish sign
          this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);

        }, 1000);
      } else if (this.signStatus === DocumentService.SLOT_SIGN_NO_ACTION || this.signStatus === DocumentService.SLOT_SIGN_STOP) {
        this.isSigning = false;
        this.signStatus = null;
        this.isSigningLotUsb = false;
      }
    });

    // call get slot info.
    this.getSlotInfo(false);

    this.dataSource = new DocumentDataSource();
    this.dataSource.data.subscribe(() => {
      this.updateSignButtonsStatus();
    });

    this.loadData();
    this.notificationService.subscribeErrorService();

    window.scrollTo(0, 0);

    // console.log(JSON.parse(localStorage.getItem('signBatchContracts')))

    this.route.queryParams.subscribe(
      params => {
        this.goFrom = params.goFrom;
        console.log(this.goFrom);
        if (this.goFrom && this.goFrom === 'signBatch') {
          this.mapDataSelected();
          this.openSignDocumentList(SignDocumentListComponent.SIGN_SLOT);
        }
      }
    );

  }

  getColumnByUser() {
    this.documentService.getColumnDynamic('CREATE_DOCUMENT_SIGN').subscribe(rs => {
      if (rs.success) {
        if (rs.data) {
          const check = JSON.parse(rs.data);
          const recordsWithDefaultTrue = check.find(item => item.default === false);
          if (recordsWithDefaultTrue) {
            this.isCheckedAllColumn = false;
          } else {
            this.isCheckedAllColumn = true;
          }
          this.columnDefinitions = this.columnDefinitions.map(ele => {
            const checkDef = check.find(item => item.def === ele.def);
            return checkDef ? {...ele, default: checkDef.default} : ele;
          });
        }
      } else {
        this.toastr.error(this.message.getMessage('messages.update_certificate_renew_server_error'));
      }
      this.getDisplayedColumns();
      this.changeWidthTable();
    });
  }

  onCheckboxChange(column: any) {
    const recordsWithDefaultTrue = this.columnDefinitions.find(item => item.default === false);
    if (recordsWithDefaultTrue) {
      this.isCheckedAllColumn = false ;
    } else {
      this.isCheckedAllColumn = true ;
    }
    this.getDisplayedColumns();
    this.changeWidthTable();
    const codeColumnByUser = {
      code: "CREATE_DOCUMENT_SIGN",
      value: JSON.stringify(this.columnDefinitions.map(item => ({
        def: item.def,
        default: item.default
      })))
    };
    this.documentService.saveColumnDynamic(codeColumnByUser)
      .subscribe(res => {
      });
  }

  onAllColumnCheckboxChange(isCheck: any) {
    if (isCheck) {
      this.columnDefinitions.forEach((column) => {
        column.default = true;
      });
    } else {
      this.columnDefinitions.forEach((column) => {
        if (!column.check) {
          column.default = false;
        }
      });
    }
    this.getDisplayedColumns();
    this.changeWidthTable();
    const codeColumnByUser = {
      code: "CREATE_DOCUMENT_SIGN",
      value: JSON.stringify(this.columnDefinitions.map(item => ({
        def: item.def,
        default: item.default
      })))
    };
    this.documentService.saveColumnDynamic(codeColumnByUser)
      .subscribe(res => {
      });
  }

  changeWidthTable() {
    const check = this.columnDefinitions.filter(item => item.default === true);
    if (this.mediaBreakpoint === SCREEN_SIZE.MD ) {
      this.tableWidth = 1650 ;
    } else {
      if (check.length > 9) {
        this.tableWidth = 1650;
      } else if (check.length <= 9) {
        this.tableWidth = 950;
      }
    }
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
      this.tableWidth = 300;
    } else if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMD && cd.default)
        .map(cd => cd.def);
      this.changeWidthTable();
    } else {
      this.displayedColumns = this.columnDefinitions.filter(cd => cd.default).map(cd => cd.def);
      this.changeWidthTable();
    }
  }

  ngAfterViewInit(page: number = 0) {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    merge(this.sort.sortChange, page)
      .pipe(
        /* tap(() => this.loadData()) */
        tap(() => this.onFilterData(this.paginate.currentPage, this.paginate.pageSize))
      )
      .subscribe();

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  ngOnDestroy() {
    // this.slotRequestTimer.unsubscribe();
    // this.notificationService.unsubscribeErrorService();
    // this.dataSource.data.unsubscribe();
    // this.documentService.signUpdateAction.unsubscribe();
    this.subscribeMediaBreakPointService.unsubscribe();
    this.downloadService.clearData();
  }

  // call api view file pdf
  viewPdf(id) {
    return this.commonService.getViewPdf(id).subscribe(
      rs => {
        this.showPdf(rs);
      }
    );
  }

  // show dialog view file pdf
  showPdf(blob: any) {
    const file = new File([blob], null, {type: 'application/pdf'});
    this.commonService.readFile(file, (pdfSrc) => {
      this.dialog.open(ViewPdfComponent, {
        width: '70%',
        data: pdfSrc,
      });
    });
  }

  /**
   * Set params for to navigate
   */
  toNavigate(route, params = {}) {
    let queryParams: any = {
      ...params,
      page: this.paginate.currentPage,
      pageSize: this.paginate.pageSize,
      routeLink: '/home-enterprise/digital-search-document/',
      documentType: this.documents.documentType,
      enterprise: this.documents.enterprise,
      nameOrCode: this.documents.nameOrCode,
      customer: this.documents.customer,
      serviceType: this.documents.type,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection,
      uuidContractMoha : this.documents.uuidContractMoha
    };

    if (!this.isBasicSearchForm) {
      queryParams = {
        ...queryParams,
        status: this.documents.status,
        taxCode: this.documents.taxCode,
        createdUser: this.documents.createdUser,
        receivedTimeFrom: this.documents.receivedTimeFrom,
        receivedTimeTo: this.documents.receivedTimeTo
      };
    }

    this.router.navigate([route], {queryParams});
  }

  // Navigate to view detail document
  viewDetail(document: any) {
    //if(!document.isEmploymentContract){
      this.toNavigate('/home-enterprise/view-document-moha-digital/' + document.id, {goFrom: 'waitSignDigital'});
    // }
    // else{
    //   if(document.status == 2 ){
    //   // this.checkTindy(() => {
    //   this.toNavigate('/home-enterprise/view-document-moha/' + document.id, {goFrom: 'waitSign'});
    //   // });
    // }else{
    //   this.toNavigate('/home-enterprise/view-document-moha/' + document.id, {goFrom: 'waitSign'});
    // }
    // }
  }

  /**
   * Detect value changing in autocomplete input
   */
  onChangeAutoCompleted() {
    if (this.selectedBranch == null) {
      this.oldData.enterprise = '';
      this.documentTypeByBranch = null;
      this.filteredDocumentTypeByBranch.next(this.documentTypeByBranch.slice());
    } else if (this.selectedBranch != null && this.selectedBranch != undefined) {
      /* this.ngForm.control.markAsDirty(); */
      this.oldData.enterprise = this.selectedBranch.id;
      this.documentTypeService.getByEnterprise(this.oldData.enterprise).subscribe(documentTypes => {
        const result = documentTypes.data;
        this.documentTypeByBranch = result;
        this.filteredDocumentTypeByBranch.next(this.documentTypeByBranch.slice());
      });
    }
  }

  getFilterCondition(page: number, pageSize: number, data): any {
    const {
      enterpriseContain,
      documentTypeContain,
      customer,
      nameOrCodeContain,
      taxCode,
      statusContain,
      nameOrCode,
      receivedTimeFrom,
      receivedTimeTo,
      finishDateFromContain,
      finishDateToContain,
      parentContainID,
      createdEnterpriseName,
      status,
      createdUser,
      contractSource,
      uuidContractMoha
    } = data;
    let filterCondition: any = {
      enterpriseId: enterpriseContain,
      docsTypeId: documentTypeContain, // mau tai lieu
      nameOrCode,
      customer,
      status,
      contractSource,
      parentId: parentContainID,
      page,
      pageSize,
      uuidContractMoha
    };

    if (!this.isBasicSearchForm) {
      filterCondition = {
        ...filterCondition,
        receivedTimeFrom,
        receivedTimeTo,
        createdUser,
        taxCode,
        finishDateFrom: finishDateFromContain,
        finishDateTo: finishDateToContain,
        createdEnterpriseName,
        serviceType: data.type
      };
    }
    let sortColumn = null;
    let sortDirection = null;

    sortDirection = this.sortDirection || 'DESC';       // if no direction >> search by receivedTime-DESC
    sortColumn = this.sortColumn || 'receivedTime';     // if no direction >> search by receivedTime-DESC

    // if (parentContainID === null) {
    //   sortDirection = this.sortDirection;
    //   sortColumn = this.sortColumn; // is searching in parent
    // } else {
    //   sortDirection = this.childSortDirection[parentContainID];
    //   sortColumn = this.sortChildColumn[parentContainID]; // is searching in child
    // }

    let column = null;

    switch (sortColumn) {
      case 'contractName':
        column = {
          contractName: sortDirection
        };
        break;
      case 'customerName':
        column = {
          creatorName: sortDirection
        };
        break;
      case 'customerTaxCode':
        column = {
          creatorCertificateNo: sortDirection,
          creatorTaxCode: sortDirection
        };
        break;
      case 'createdEmail':
        column = {
          creatorEmail: sortDirection
        };
        break;
      case 'receivedTime':
        column = {
          receivedTime: sortDirection
        };
        break;
      case 'createdUser':
        column = {
          createdUser: sortDirection
        };
        break;
    }

    filterCondition['sorts'] = column;
    return filterCondition;
  }

  onToggleChange(cdkDetailRow: CdkDetailRowDirective, row): void {
    if (this.singleChildRowDetail && this.openedRow && this.openedRow.expended) {
      this.openedRow.toggle();
    }

    if (!row.close) {
      row.close = true;
    } else {
      row.close = false;
    }
    this.openedRow = cdkDetailRow.expended ? cdkDetailRow : undefined;
  }

  /**
   * Count record to show
   */
  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  /**
   * Get data when init
   */
  loadData(page: number = 0, pageSize: number = 10) {
    let paramEnterprise: '';
    let paramDocumentType: '';
    let paramNameOrCode: '';
    let paramCustomer: '';
    let paramServiceType: any;
    let paramTaxCode: '';
    let paramCreatedUser: '';
    let paramReceivedTimeFrom: any;
    let paramReceivedTimeTo: any;
    let paramStatus: number;
    let paramContractSource: any;
    let paramuuidContractMoha: '';

    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        paramEnterprise = params.enterprise;
        paramDocumentType = params.documentType;
        paramNameOrCode = params.nameOrCode;
        paramCustomer = params.customer;
        paramServiceType = isNaN(parseInt(params.serviceType)) ? null : parseInt(params.serviceType);
        paramTaxCode = params.taxCode;
        paramCreatedUser = params.createdUser;
        paramReceivedTimeFrom = params.receivedTimeFrom != null ? new Date(params.receivedTimeFrom) : null;
        paramReceivedTimeTo = params.receivedTimeTo != null ? new Date(params.receivedTimeTo) : null;
        page = params.page || 0;
        pageSize = params.pageSize && params.pageSize > 0 ? params.pageSize : 10;
        this.sortColumn = params.sortColumn || null;
        this.sortDirection = params.sortDirection || null;
        paramStatus = params.status;
        paramContractSource = params.contractSource != null && params.contractSource !== '' ? parseInt(params.contractSource) : null;
        paramuuidContractMoha = params.uuidContractMoha;
      });

    this.documents.enterprise = paramEnterprise;
    this.documents.documentType = paramDocumentType;
    this.documents.nameOrCode = paramNameOrCode || null;
    this.documents.customer = paramCustomer;
    this.documents.type = paramServiceType || null;
    this.documents.taxCode = paramTaxCode;
    this.documents.createdUser = paramCreatedUser;
    this.documents.receivedTimeFrom = paramReceivedTimeFrom;
    this.documents.receivedTimeTo = paramReceivedTimeTo;
    this.documents.status = paramStatus ? Number(paramStatus) : null;
    this.documents.contractSource = paramContractSource;
    this.documents.uuidContractMoha = paramuuidContractMoha;
    if (this.dataStateUrl) {
      if (this.dataStateUrl.key === 'analysis-report-enterprise') {
        this.documents.status = 2;
      }
    }
    if (paramServiceType || paramTaxCode || paramCreatedUser
      || paramReceivedTimeFrom || paramReceivedTimeTo) {
      this.isBasicSearchForm = false;
    }

    // DESC or ASC
    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }
    const dataFilter = {
      paramEnterprise,
      paramDocumentType,
      paramNameOrCode,
      paramCustomer,
      paramServiceType,
      paramTaxCode,
      paramCreatedUser,
      paramReceivedTimeFrom,
      paramReceivedTimeTo,
      status: this.documents.status,
      contractSource: this.documents.contractSource,
      paramuuidContractMoha: paramuuidContractMoha
    };
    this.documentService.searchDocumentWaitSignDigital(this.getFilterCondition(page, pageSize, dataFilter))
      .subscribe(rs => {
        if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
          && rs.data.totalRow != null) {
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
        }
        if (rs.data && rs.data.dataRow != null) {
          this.initParent(rs);
        }
      });
  }

  sortData(sort: Sort) {

    if (!sort.active || sort.direction === '') {
      return;
    }
    this.sortColumn = sort.active;
  }

  /**
   * Filter data with condition
   */
  onFilterData(page: number = 0, pageSize: number = 10) {

    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }

    } else {
      this.isFirstLoad = false;
    }
    this.documentService.searchDocumentWaitSignDigital(this.getFilterCondition(page, pageSize, this.oldData))
      .subscribe(
        rs => {
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
          this.initParent(rs);

          if (this.isBasicSearchForm) {
            this.documents.receivedTimeFrom = null;
            this.documents.receivedTimeTo = null;
            this.documents.createdUser = null;
          }
        }
      );
  }

  initParent(rs: any): void {
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;
    this.parentDocuments = rs.data.dataRow;
    this.waitSignDocsCount = 0;
    this.parentDocuments.forEach(parent => {
      parent.taxCode = (parent.customerTaxCode == null || parent.customerTaxCode === '') ?
        parent.customerCertificateNo : parent.customerTaxCode;
      parent['STT'] = stt++;
      this.childPaginateList[parent.id] = new Paginate();
      this.childOldDataList[parent.id] = new Document();
      this.childSortList[parent.id] = new MatSort();
      if (parent.status === 2) {
        this.waitSignDocsCount++;
      }
    });
    this.initDataSelected();
    this.dataSource.setData(this.parentDocuments);
    this.childIsExpanding = []; // close all parent
  }

  initDataSelected() {
    if (this.dataSelected.length === 0) {
      return;
    }

    let countCheck = 0;
    this.dataSelected.forEach(data => {
      if (data.checked) {
        const index = this.parentDocuments.findIndex(item => item.id === data.id);
        if (index !== -1) {
          countCheck++;
          this.parentDocuments[index].checked = true;
        }
      }
    });

    // check all enable.
    if (countCheck === this.parentDocuments.length && countCheck > 0) {
      this.checkAll = true;
    } else {
      this.checkAll = false;
    }
  }

  onClickBtnFilter() {
    this.oldData = {...this.documents};
    console.log('this.oldData::', this.oldData);
    this.countCheck = 0;
  }

  /**
   * Open PDF By Browser
   */
  openPDFByBrowser(documentData: any) {
    if (documentData.id) {
      this.documentService.downloadFileZip(documentData.id).subscribe(res => {
        const blobUrl = URL.createObjectURL(res);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.download = documentData.name + '.zip';
        a.click();
      });
    }
  }

  multiDownload() {
    this.downloadService.setData({
      contractIds: this.dataSelected.map(e => e.id),
      menuContract: EnumDownloadMenuName.SEARCH_DOCUMENT_SIGN,
    });
  }

  /**
   * Copy document
   */
  copyDocument(id: string) {
    if (id) {
      if (this.documents.documentType === 1) {
        this.toastr.error(this.message.getMessage('messages.document_no_copy'));
      } else {
        this.toNavigate('/home-enterprise/update-document/' + id, {
          flagCopy: true
        });
      }
    }
  }

  /**
   * Open signing progress popup.
   */
  handleSingingProcess() {
    console.log('thissssssssss', this);

    if (this.typeCertificate == EnumSignMethod.SIGN_SERVER) {
      this.openSigningProgressPopup();
    }

    if (this.typeCertificate == EnumSignMethod.CLOUD_CA) {
      this.openSigningProgressCloudCaPopup();
    }

    if (this.typeCertificate == EnumSignMethod.SIGN_USB_TOKEN) {
      this.openSigningProgressUsbTokenPopup();
    }

  }

  openSigningProgressPopup() {
    this.isSigning = false;
    const popup = this.dialog.open(SignProgressComponent, {
      width: '80%',
      data: {
        isFinished: this.signStatus === DocumentService.SLOT_SIGN_FINISH
      }
    });

    popup.componentInstance.actions.subscribe(ac => {
      // close popup.
      switch (ac) {
        case SignProgressComponent.STOP_ACTION:
        case SignProgressComponent.FINISH_ACTION:
          // replace background by sign slot & sign all
          // reload data.
          this.isSigning = false;
          popup.close();
          this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          break;
        case SignProgressComponent.CLOSE_ACTION:
          this.isSigning = true;
          popup.close();
          this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          break;
        default:
          break;
      }
    });
  }

  openSigningProgressCloudCaPopup() {
    this.isSigning = false;
    const popup = this.dialog.open(SignProgressCloudCaComponent, {
      width: '80%',
      data: {
        isFinished: this.signStatus === DocumentService.SLOT_SIGN_FINISH,
        hasTransSaved: this.hasTransSavedCloudCA
      }
    });

    this.dialogRef = popup;

    popup.componentInstance.actions.subscribe(ac => {
      // close popup.
      switch (ac) {
        case SignProgressCloudCaComponent.STOP_ACTION:
        case SignProgressCloudCaComponent.FINISH_ACTION:
          // replace background by sign slot & sign all
          // reload data.
          this.isSigning = false;
          popup.close();
          this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          break;
        case SignProgressCloudCaComponent.CLOSE_ACTION:
          this.isSigning = true;
          popup.close();
          this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          this.getSlotInfo(true);
          break;
        default:
          break;
      }
    });
  }

  openSigningProgressUsbTokenPopup() {
    this.isSigning = false;
    const popup = this.dialog.open(SignProgressUsbTokenComponent, {
      width: '80%',
      data: {
        isFinished: this.signStatus === DocumentService.SLOT_SIGN_FINISH
      }
    });

    popup.componentInstance.actions.subscribe(ac => {
      // close popup.
      switch (ac) {
        case SignProgressUsbTokenComponent.STOP_ACTION:
        case SignProgressUsbTokenComponent.FINISH_ACTION:
          // replace background by sign slot & sign all
          // reload data.
          this.isSigning = false;
          popup.close();
          this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          break;
        case SignProgressUsbTokenComponent.CLOSE_ACTION:
          this.isSigning = true;
          popup.close();
          this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          break;
        default:
          break;
      }
    });
  }

  showErrMsgTransleFormat(msg) {
    this.toastr.error(this.message.getMessage(msg));
  }

  showErrMsgTransle(msg) {
    this.toastr.error(this.message.getMessage(msg));
  }

  setSessionId(value) {
    this.sessionId = value;
  }

  setCertData(value) {
    this.sign.certificate = value;
  }

  checkAuthenVneid(callback?: () => void) {
    this.documentMohaService.getCheckVneidConfirm(null, true).subscribe(res => {
      if (res.success) {
        this.dataCheckVneid = res.data;
        switch (this.dataCheckVneid.typeVerify) {
          case 'SHARE_INFO': 
            this.openRequestConfirmIdentity(callback);
            break;
          case 'FACE_MATCH': 
          this.openRequestConfirmIdentity(callback);
            break;
          case 'VERIFIED': 
            if (callback) {
              callback();
            };
            break;
        }
      } else {
        this.toastr.error(res.message);
      }
    })
  }

  private openRequestConfirmIdentity(callback?: () => void): void {
    const dialogRef = this.dialog.open(RequestConfirmIdentityComponent, {
      width: this.deviceService.isMobile() ? '100%' : '640px',
      panelClass: 'scontract-overlay-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.openEnterIdentityVneid(callback);
      }
    });
  }

  private openEnterIdentityVneid(callback?: () => void): void {
    const dialogRef = this.dialog.open(EnterIdentityVneidComponent, {
      panelClass: 'sign-authentication',
      width: '1080px',
      maxWidth: '90vw',
      height: 'auto',
      disableClose: true,
      data: {
        documentId: null,
        dataCheckVneid: this.dataCheckVneid,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        this.openRequestConfirmIdentity(callback);
        return;
      } else {
        callback();
      }
    });
  }

  /**
   * Open sign slot of document.
   */
   openSignSlot() {
    const listApproverSignMoha = this.dataSelected.filter(doc => doc.status == 2 && doc.isEmploymentContract);
    if (listApproverSignMoha.length > 0) {
      if (this.userType == 1 || this.userType == 2 || this.userType == 5) {
        this.checkAuthenVneid(() => this.actionSignLot());
        return
      }
      this.actionSignLot();
    }
    this.openSignDocumentList(SignDocumentListComponent.SIGN_SLOT);
  }

  actionSignLot() {
    this.checkTindy(() => {
      this.openSignDocumentList(SignDocumentListComponent.SIGN_SLOT);
    });
  }
//    openSignSlot() {
//       // console.log("..." + this.dataSource)
//       if(Number(this.userType) === 5){
//         if(this.isConfirmVNeID){
//           const dialogRef = this.dialog.open(DowloadAppVContractComponent, {
//             width: this.deviceService.isMobile() ? '100%' : '60%',
//             maxWidth: this.deviceService.isMobile() ? '90vw' : '40vw',
//             panelClass: 'scontract-overlay-dialog',
//             disableClose: true,
//           });
//           dialogRef.afterClosed().subscribe(() => {});
//         }else{
//           this.documentMohaService.getCheckVneidConfirm('', true).subscribe({
//             next: rs2 => {
//               if (rs2 && rs2.success === true) {
//                 if(rs2.data === "FACE_MATCH"){
//                   const dialogRef = this.dialog.open(DowloadAppVContractComponent, {
//                     width: this.deviceService.isMobile() ? '100%' : '60%',
//                     maxWidth: this.deviceService.isMobile() ? '90vw' : '40vw',
//                     panelClass: 'scontract-overlay-dialog',
//                     disableClose: true,
//                   });
//                   dialogRef.afterClosed().subscribe(() => {});
//                 }else if(rs2.data === "VERIFIED"){
//                   this.letSignSlot();
//                 }
//
//               } else {
//                 this.toastr.error(rs2.message);
//               }
//             },
//             error: err => {
//               console.error('DEBUG error:', err);
//             }
//           });
//         }
//       }else{
//         this.letSignSlot();
//       }
//     }
//
//     letSignSlot(){
//       let checkEmploymentContract = false;
//
//       // check isEmploymentContract
//       this.dataSelected.forEach(data => {
//         if(data.isEmploymentContract == true){
//           checkEmploymentContract = true;
//         }
//       });
//
//       // isEmploymentContract = true
//       if(checkEmploymentContract) {
//         // Check Tindy - truyền callback vào
//         this.checkTindy(() => {
//           this.openSignDocumentList(SignDocumentListComponent.SIGN_SLOT);
//         });
//
//       // isEmploymentContract = false
//       } else {
//         this.openSignDocumentList(SignDocumentListComponent.SIGN_SLOT);
//       }
//     }

  /**
   * Open Sign all dialog
   */
  openSignAll() {
    // const listApproverSignMoha = this.dataSelected.filter(doc => doc.status == 2 && doc.isEmploymentContract);
    // if (listApproverSignMoha.length > 0) {
    //   if (this.userType == 1 || this.userType == 2 || this.userType == 5) {
    //     this.checkAuthenVneid(() => this.actionSignAll());
    //     return
    //   }
    //   this.actionSignAll();
    // }
    this.openSignDocumentList(SignDocumentListComponent.SIGN_ALL);
  }

  // actionSignAll() {
  //   this.checkTindy(() => {
  //     this.openSignDocumentList(SignDocumentListComponent.SIGN_ALL);
  //   });
  // }

  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }


  createTransaction(contract) {

    //can them isConfirmBCT
    this.blockUI.reset();
    this.blockUI.start('');
    if (contract.isConfirmBCT) {

      const body = {
        signMethod: EnumSignMethod.SIGN_USB_TOKEN,
        contractId: contract.id,
        // signPositions: this.signImages
      };
      this.documentService.createTimestampMoney(body).subscribe(
        res => {
          this.blockUI.stop();
          if (res && !res.success) {
            if (res.code === ErrorCode.NotEnoughMoneyTimestamp) {
              this.showErrMsgTransle('digital_certificate_management.out_of_money_timestamp');
              // this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
            } else {
              this.toastr.error(res.message);
            }
          } else {
            this.signTransactionId = res.data;
            // this.onClickSignButton()
          }
        }
      );
    } else {
      // this.signImages = imagePreSort;
      this.blockUI.stop();
      // this.onClickSignButton();

    }
  }

  // }

  /**
   * check disabled sign slot button or not.
   */
  public updateSignButtonsStatus() {
    if (this.dataSource == null
      || this.dataSource.data == null
      || this.dataSource.data.value == null
      || this.dataSource.data.value.length === 0) {
      return;
    }

    this.countCheck = 0;
    this.countContract = 0;
    this.dataSource.data.value.forEach(data => {
      if (data.checked) {
        this.countCheck++;
      }
      this.countContract++;

      const index = this.dataSelected.findIndex(item => item.id === data.id);
      if (index !== -1 && !data.checked) {
        this.dataSelected.splice(index, 1);
      } else if (index === -1 && data.checked) {
        const found = this.signedContract.find(el => el == data.id);
        if (found === undefined) {
          this.dataSelected.push(data);
        }
      }
      for (let i = 0; i < this.signedContract.length; i++) {
        const tmp = this.dataSelected.findIndex(item => item.id === this.signedContract[i]);
        if (tmp !== -1) {
          this.dataSelected.splice(tmp, 1);
        }
      }

    });

    // check all enable.
    if (this.countCheck === this.countContract && this.countCheck > 0) {
      this.checkAll = true;
    } else {
      this.checkAll = false;
    }
  }

  /**
   * check box change event.
   * @param item document item.
   * @param isChecked status of checkbox.
   */
  public onSelectionChange() {
    this.updateSignButtonsStatus();
  }

  /**
   * check all displayed documents.
   */
  public checkAllDocument() {
    this.dataSource.data.value.forEach(data => {
      data.checked = this.checkAll;
    });

    this.updateSignButtonsStatus();
  }

  /**
   * open sign document list.
   * @param signOption sign option.
   */
  typeCertificate = EnumSignMethod.SIGN_SERVER;

  private openSignDocumentList(signOption: string) {

    if (this.signedContract.length > 0) {
      this.updateSignButtonsStatus();
    }

    if (signOption !== SignDocumentListComponent.SIGN_ALL && !this.dataSelected.some(d => d.status === 2 && d.cStatus !== 3 && d.cStatus !== 5)) {
      const popup = this.dialog.open(NotifyWarningCustomComponent, {
        width: '600px',
        data: {
          content: this.commonService.format(this.message.getMessage('messages.reject_sign_by_lot')),
        }
      });
    } else {
      const popup = this.dialog.open(SignDocumentListComponent, {
        width: '80%',
        data: {
          signOption,
          slotDocuments: new BehaviorSubject<Document[]>(this.dataSelected),
          filterSignAll: (
            this.getFilterCondition(0, 0, this.oldData)
          ),
        }
      });
      popup.componentInstance.actions.subscribe(ac => {
        let datasource = null;

        switch (ac) {
          case SignDocumentListComponent.CONFIRM_ACTION:
            datasource = popup.componentInstance.dataSource;
            popup.close();
            break;
          case SignDocumentListComponent.CLOSE_ACTION:
            if (this.goFrom && this.goFrom === 'signBatch') {
              localStorage.removeItem('signBatchContracts');
            }
            popup.close();
            popup.componentInstance.actions.unsubscribe();
            break;
        }

        if (!datasource) {
          return;
        }

        datasource = datasource.map(_doc => {
          const found = this.signedContract.find(el => el == _doc.id);
          if (found === undefined) {
            return _doc;
          }

        });

        const popup2 = this.dialog.open(SignDocumentComponent, {
          width: '40%',
          data: {
            type: SignDocumentComponent.SIGN_SLOT,
            document: datasource
          }
        });

        popup2.componentInstance.actions.subscribe((ac) => {

          const imageSignSystem = this.documentService.systemSignImage.value || null;
          switch (ac) {
            case SignDocumentComponent.CONFIRM_ACTION:
              const slotIds = [];
              // get document ids.
              datasource.forEach(doc => {
                slotIds.push(doc.id);
              });
              this.typeCertificate = popup2.componentInstance.selectedCert.typeCertificate;
              const idDetail = popup2.componentInstance.selectedCert.idDetail;
              this.digitalCertificateId = popup2.componentInstance.selectedCert.id;
              this.serialNumberChoose = popup2.componentInstance.selectedCert.serialNumber;
              this.signLotImage = popup2.componentInstance.selectedCert.imagePath ? true : false;
              this.imageBase64 = popup2.componentInstance.selectedCert.imagePath;
              // submit sign to server.
              if (this.typeCertificate == EnumSignMethod.SIGN_SERVER) {
                this.documentService.submitSignedDocuments(slotIds, imageSignSystem)
                  .subscribe(rs => {
                    if (rs.data) {
                      this.openSigningProgressPopup();
                    }

                    // else display error message at top right.
                  });
              } else if (this.typeCertificate == EnumSignMethod.CLOUD_CA) {

                this.hasTransSavedCloudCA = popup2.componentInstance.selectedCert.hasTransSaved;
                if(this.hasTransSavedCloudCA){
                  this.blockUI.start()
                  this.documentService.submitSignMultiSessionCloudCa(slotIds, idDetail, imageSignSystem)
                  .pipe(finalize(()=>{
                    this.blockUI.stop();
                    this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
                  }))
                  .subscribe(rs => {
                    if (rs.success) {
                      this.openSigningProgressCloudCaPopup();
                    } else {
                      this.toastr.error(rs.message);
                      // if (rs.code == ErrorCode.isContractProcess) {
                      //   this.toastr.error("Dang co lo xu ly, vui long thu lai sau it phut")
                      // }
                    }

                    // else display error message at top right.
                  });
                } else {
                  this.blockUI.start()
                  this.documentService.submitSignMultiCloudCa(slotIds, idDetail, imageSignSystem)
                  .pipe(finalize(()=>{
                    this.blockUI.stop();
                    this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
                  }))
                  .subscribe(rs => {
                    if (rs.success) {
                      this.openSigningProgressCloudCaPopup();
                    } else {
                      this.toastr.error(rs.message);
                      // if (rs.code == ErrorCode.isContractProcess) {
                      //   this.toastr.error("Dang co lo xu ly, vui long thu lai sau it phut")
                      // }
                    }

                    // else display error message at top right.
                  });
                }
              } else if (this.typeCertificate == EnumSignMethod.SIGN_USB_TOKEN) {
                //TODO: handler method sign multi cloud ca
                this.digitalCertificateDetailId = idDetail;

                const contracts = datasource.map(_doc => {
                  const found = this.signedContract.find(el => el == _doc.id);
                  if (found === undefined) {
                    return {
                      nameContract: _doc.contractName,
                      numberOfFiles: _doc.contractAttachments.length
                    };
                  }
                });
                this.contractsForSign = datasource;

                this.handleB64Image(this.imageBase64);

                initPluginCertificate(this, contracts);
              }

              popup2.close();
              // this.blockUI.reset();
              // this.blockUI.start('');
              popup2.componentInstance.actions.unsubscribe();
              break;
            case SignDocumentComponent.CLOSE_ACTION:
              popup2.close();
              popup2.componentInstance.actions.unsubscribe();
              this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
              break;
            default:
              break;
          }//
        });
      });
    }
  }


  async processSignLotUsingUsbToken() {
    if (this.serialNumberChoose !== this.sign.serialNumber) {
      this.showErrMsgTransle('messages.select_certificate_failed');
      return;

    }

    // init lo usb token
    this.blockUI.reset();
    this.blockUI.start('');
    const rs = await this.documentService.usbTokenInitSignGroup({
      contracts: this.contractsForSign.map(contract => contract.id),
      digitalCertificateDetailId: this.digitalCertificateDetailId,
      certificate: this.sign.certRawdata
    }).toPromise();
    if (rs && rs.success) {
      this.blockUI.stop();
      this.openSigningProgressUsbTokenPopup();
      this.isSigningLotUsb = true;
      this.userCancel = false;
      // this.cancelCalls = [];

      let result = true;

      for await (const contract of this.contractsForSign) {

        const found = this.signedContract.find(el => el == contract.id);
        console.log(found);
        if (found === undefined) {
          if (rs.data[contract.id] && !this.userCancel) {
            // result = await this.signContract(contract, rs.data[contract.id])
            result = await this.signBatchContracts(contract, rs.data[contract.id]);
          } else {
            continue;
          }
        }
      }

      if (this.userCancel) {
        await this.documentService.cancelSignBatch().toPromise();
      }

    } else {
      this.blockUI.stop();
    }
  }

  /**
   * sign batch usb token
   * @param contracts contracts need to signs
   * @param allSignPositions all sign positions of that list contracts
   */
  async signBatchContractsSvc(contract, signPositions) {
    const mainContractAttachmentsNew = [];
    let isSuccess = true;

    if (!this.isSigningLotUsb) {
      console.log('stop signing call cancel sign');
      this.signDone(contract, mainContractAttachmentsNew, false, null);
      return;
    }

    // if (this.userCancel) {
    // 	this.cancelCalls.push(this.signDone(contract, mainContractAttachmentsNew, false, null));
    // 	return;
    // }

    let attachmentSignPosMap = new Map();
    let loopNo = 0;
    contract.contractAttachments.forEach(attachment => {
      let signPos = signPositions.filter(el => el.fileId == this.decodeId(attachment.id));
      attachmentSignPosMap.set(attachment, signPos);
      if (signPos.length >= loopNo) {
        loopNo = signPos.length;
      }
    });

    let prevData = null;

    for await (let index of Array.from(Array(loopNo).keys())) {
      // while (!(index >= loopNo)) {
      let lstDto = [];
      let rs = null;
      if (!this.isSigningLotUsb) {
        await this.signDone(contract, mainContractAttachmentsNew, false, null);
        return;
      }
      const imageSignSystem = this.documentService.systemSignImage.value || null;
      attachmentSignPosMap.forEach((v, k) => {
        let signPos = v[index];
        let dto = {
          contractId: contract.id,
          digitalCertificateId: this.digitalCertificateId,
          digitalCertificateDetailId: this.digitalCertificateDetailId,
          certificate: this.sign.certRawdata,
          path: null,
          fileId: null,
          position: null,
          oldPath: null,
          id: null,
          idDetail: null,
          enterpriseId: null,
          typeCertificate: null,
          serialNumber: null,
          image: null,
          base64Image: imageSignSystem,
          certRawdata: null,
        };
        dto.path = k.path;
        dto.fileId = signPos.fileId;
        dto.position = signPos;
        dto.typeCertificate = '1';
        if (prevData) {
          dto.oldPath = prevData.filter(data => data.fileId == k.id)[0].path;
        }

        if (this.signLotImage) {
          dto.contractId = contract.id;
          dto.digitalCertificateId = this.digitalCertificateId;
          dto.digitalCertificateDetailId = this.digitalCertificateDetailId;
          dto.id = this.digitalCertificateId;
          dto.idDetail = this.digitalCertificateDetailId;
          dto.enterpriseId = localStorage.getItem('enterpriseId');
          dto.typeCertificate = '1';
          dto.serialNumber = this.sign.serialNumber;
          dto.certificate = this.sign.certRawdata;
          dto.certRawdata = this.sign.certRawdata;
          dto.position = JSON.stringify(signPos);
          dto.base64Image = imageSignSystem;
        }
        lstDto.push(dto);
      });
      // attachmentSignPosMap.forEach((v, k) => {
      // 	let signPos = v[index];
      // 	console.log(k, signPos)
      // })
      // attachmentSignPosMap.forEach((v, k) => {
      // 	console.log(k)
      // })
      // console.log("chuan bi hash: ", this.isSigningLotUsb)
      if (!this.signLotImage) {
        rs = await this.documentService.createMultiHashNoImage({models: lstDto}, true).toPromise();
      } else {
        rs = await this.documentService.createMultiHashImage(lstDto, true).toPromise();
      }

      // console.log("res hash: " + JSON.stringify(rs));

      // if (this.expiredBatch) {
      // 	await this.signDone(contract, mainContractAttachmentsNew, false, rs ? rs.data ? rs.data.signTransactionId : null : null);
      // 	return;
      // }

      if (rs && !rs.success) {
        isSuccess = false;
        await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
        break;
      }
      if (!rs) {
        isSuccess = false;
        await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
        break;
      }
      if (rs && rs.data) {
        prevData = rs.data;
        rs.data.forEach(el => {
          mainContractAttachmentsNew.push({path: el.path, id: el.fileId});
        });
      }

      let sig = null;

      try {

        sig = await signHashNormal(this, JSON.stringify(rs.data), this.sessionId, this.sign.serialNumber);
      } catch (err) {
        isSuccess = false;
        this.userCancel = true;
        // console.log("sign return js -> ts ", sig)
        // await this.documentService.cancelSignBatch().toPromise()
        return;
      }

      if (this.expiredBatch) {
        this.userCancel = true;
        sig = null;
      }

      // if (this.expiredBatch) {
      // 	await this.signDone(contract, mainContractAttachmentsNew, false, rs ? rs.data ? rs.data.signTransactionId : null : null);
      // 	return;
      // }

      if (sig) {
        let lstSignDto = [];
        sig.forEach(signature => {
          let signDTO = {
            path: rs.data.filter(o => o.fileId == signature.fileId)[0].path,
            signPdf: rs.data.filter(o => o.fileId == signature.fileId)[0].signPdf,
            contractId: contract.id,
            signature: signature.signatureBase64,
            fileId: this.decodeId(signature.fileId),
            position: signPositions.filter(pos => pos.fileId == this.decodeId(signature.fileId))[index],
            signPositions: signPositions,
          };
          lstSignDto.push(signDTO);
        });
        const resSign = await this.documentService.signBatchUsb(lstSignDto, true).toPromise();

        if (resSign && !resSign.success) {
          isSuccess = false;
          await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
          break;
        }
        if (!resSign || !resSign.data) {
          isSuccess = false;
          await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
          break;
        }
        if (resSign && resSign.success && index + 1 === loopNo) {
          if (!this.isSigningLotUsb || this.expiredBatch) {
            console.log('stop signing call cancel sign');
            isSuccess = false;
            await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
            return;
          }
          await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
        }

      } else {
        isSuccess = false;

        await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
        break;
      }

      // index++;
    }

    return isSuccess;
  }

  /**
   * sign batch usb token
   * @param contracts contracts need to signs
   * @param allSignPositions all sign positions of that list contracts
   */
  async signBatchContracts(contract, signPositions) {
    const mainContractAttachmentsNew = [];
    let isSuccess = true;

    if (!this.isSigningLotUsb) {
      console.log('stop signing call cancel sign');
      this.signDone(contract, mainContractAttachmentsNew, false, null);
      return;
    }

    // if (this.userCancel) {
    // 	this.cancelCalls.push(this.signDone(contract, mainContractAttachmentsNew, false, null));
    // 	return;
    // }

    let attachmentSignPosMap = new Map();
    let loopNo = 0;
    contract.contractAttachments.forEach(attachment => {
      let signPos = signPositions.filter(el => el.fileId == this.decodeId(attachment.id));
      attachmentSignPosMap.set(attachment, signPos);
      if (signPos.length >= loopNo) {
        loopNo = signPos.length;
      }
    });

    let prevData = null;

    let lstDto = [];
    let rs = null;
    if (!this.isSigningLotUsb) {
      await this.signDone(contract, mainContractAttachmentsNew, false, null);
      return;
    }
    const imageSignSystem = this.documentService.systemSignImage.value || null;
    attachmentSignPosMap.forEach((v, k) => {
      let signPos = v[0];
      let dto = {
        contractId: contract.id,
        digitalCertificateId: this.digitalCertificateId,
        digitalCertificateDetailId: this.digitalCertificateDetailId,
        certificate: this.sign.certRawdata,
        path: null,
        fileId: null,
        position: null,
        signPositions: null,
        oldPath: null,
        id: null,
        idDetail: null,
        enterpriseId: null,
        typeCertificate: null,
        serialNumber: null,
        image: null,
        base64Image: imageSignSystem,
        certRawdata: null,
      };
      dto.path = k.path;
      dto.fileId = signPos.fileId;
      dto.position = signPos;
      dto.signPositions = v;
      dto.typeCertificate = '1';
      if (prevData) {
        dto.oldPath = prevData.filter(data => data.fileId == k.id)[0].path;
      }

      if (this.signLotImage) {
        dto.contractId = contract.id;
        dto.digitalCertificateId = this.digitalCertificateId;
        dto.digitalCertificateDetailId = this.digitalCertificateDetailId;
        dto.id = this.digitalCertificateId;
        dto.idDetail = this.digitalCertificateDetailId;
        dto.enterpriseId = localStorage.getItem('enterpriseId');
        dto.typeCertificate = '1';
        dto.serialNumber = this.sign.serialNumber;
        dto.certificate = this.sign.certRawdata;
        dto.certRawdata = this.sign.certRawdata;
        dto.position = JSON.stringify(signPos);
        dto.signPositions = JSON.stringify(v)
        dto.base64Image = imageSignSystem;
      }
      lstDto.push(dto);
    });
    // attachmentSignPosMap.forEach((v, k) => {
    // 	let signPos = v[index];
    // 	console.log(k, signPos)
    // })
    // attachmentSignPosMap.forEach((v, k) => {
    // 	console.log(k)
    // })
    // console.log("chuan bi hash: ", this.isSigningLotUsb)
    if (!this.signLotImage) {
      rs = await this.documentService.createMultiHashNoImage({models: lstDto}, true).toPromise();
    } else {
      rs = await this.documentService.createMultiHashImage(lstDto, true).toPromise();
    }

    // console.log("res hash: " + JSON.stringify(rs));

    // if (this.expiredBatch) {
    // 	await this.signDone(contract, mainContractAttachmentsNew, false, rs ? rs.data ? rs.data.signTransactionId : null : null);
    // 	return;
    // }

    if (rs && !rs.success) {
      isSuccess = false;
      await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
      return isSuccess;
    }
    if (!rs) {
      isSuccess = false;
      await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
      return isSuccess;
    }
    if (rs && rs.data) {
      prevData = rs.data;
      rs.data.forEach(el => {
        mainContractAttachmentsNew.push({path: el.path, id: el.fileId});
      });
    }

    let sig = null;

    try {

      sig = await signHashNormal(this, JSON.stringify(rs.data), this.sessionId, this.sign.serialNumber);
    } catch (err) {
      isSuccess = false;
      this.userCancel = true;
      // console.log("sign return js -> ts ", sig)
      // await this.documentService.cancelSignBatch().toPromise()
      return;
    }

    if (this.expiredBatch) {
      this.userCancel = true;
      sig = null;
    }

    // if (this.expiredBatch) {
    // 	await this.signDone(contract, mainContractAttachmentsNew, false, rs ? rs.data ? rs.data.signTransactionId : null : null);
    // 	return;
    // }

    if (sig) {
      let lstSignDto = [];
      sig.forEach(signature => {
        let signDTO = {
          path: rs.data.filter(o => o.fileId == signature.fileId)[0].path,
          signPdf: rs.data.filter(o => o.fileId == signature.fileId)[0].signPdf,
          contractId: contract.id,
          signature: signature.signatureBase64,
          fileId: this.decodeId(signature.fileId),
          position: signPositions.filter(pos => pos.fileId == this.decodeId(signature.fileId))[0],
          signPositions: signPositions,
        };
        lstSignDto.push(signDTO);
      });
      const resSign = await this.documentService.signBatchUsb(lstSignDto, true).toPromise();

      if (resSign && !resSign.success) {
        isSuccess = false;
        await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
        return isSuccess;
      }
      if (!resSign || !resSign.data) {
        isSuccess = false;
        await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
        return isSuccess;
      }
      if (resSign && resSign.success) {
        if (!this.isSigningLotUsb || this.expiredBatch) {
          console.log('stop signing call cancel sign');
          isSuccess = false;
          await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
          return;
        }
        await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
      }

    } else {
      isSuccess = false;

      await this.signDone(contract, mainContractAttachmentsNew, isSuccess, rs ? rs.data ? rs.data.signTransactionId : null : null);
      return isSuccess;
    }

    // index++;


    return isSuccess;
  }

  async handleB64Image(base64) {
    if (base64 == null || base64 == undefined) {
      return;
    }
    const imageDataBlob = this.commonService.b64toBlob(base64);
    const blobUrl = URL.createObjectURL(imageDataBlob);
    if (blobUrl) {
      await fetch(blobUrl)
        .then(r => r.blob())
        .then(blobFile => {
          this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
        });
    }
  }

  async signDone(contract, mainContractAttachmentsNew, isSuccess, signTransactionId) {
    // return new Promise((resolve, reject) => {
    const data = {
      signTransactionId: null,
      userCancel: false,
      signMethod: this.typeCertificate,
      contractId: contract.id,
      mainContractAttachments: mainContractAttachmentsNew,
      certificate: this.sign.certificate.certBase64,
      digitalCertificateDetailId: this.digitalCertificateDetailId
    };
    if (isSuccess) {
      //done sign
      // this.isCallDone = true;
      console.log('call done sign');
      console.log('push signedcontract: ' + contract.id);
      this.signedContract.push(contract.id);
      const res = await this.signDocumentService.signDone(data, true).toPromise();
      // .subscribe(res => {
      if (res && res.data) {
        // return isSuccess
      } else {
        console.log('done sign fail');
        const index = this.signedContract.findIndex(el => el === contract.id);
        if (index !== -1) {
          this.signedContract.splice(index, 1);

        }

      }
      // else {
      //   this.isCallDone = false;
      // }
      // },
      // err => {
      //   console.error(err)
      //   this.message.getMessage('messages.sign_fail');
      //   // isSuccess = false;
      // })
    } else {
      console.log('call cancel sign');
      data.userCancel = true;
      const res = await this.signDocumentService.signCancel(data, true).toPromise();
      console.log('cancel res ', JSON.stringify(res));
    }
    if (isSuccess) {
      // resolve(isSuccess);
    } else {
      // reject(isSuccess)

    }

    // })
  }


  onSearch(page: number = 0, pageSize: number = 10) {
    this.oldData = {...this.documents};
    this.onFilterData(page, pageSize);
  }

  /**
   * Load data from data.
   * Format of returned result.
   * {
   *    "info": {
   *      "id": "string",
   *      "createdTime": "DATE",
   *      "cancelTime": "",
   *      "description": "",
   *      "success": false,
   *      "details": [
   *        {
   *          "contractId": "",
   *          "status": 0,
   *          "description": ""
   *        }
   *      ]
   *    },
   *    "contracts": "json string array of contracts"
   * }
   */
  private getSlotInfo(hasPreviousData) {
    // enable calling flag.
    // this.isReadyToCalling = false;

    this.documentService.getSlotStatus(hasPreviousData);
  }

  /**
   * Open advanced search form
   */
  onExpandAdvancedSearchForm() {
    this.isBasicSearchForm = false;
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  /**
   * Close advanced search form
   */
  onCloseAdvancedSearchForm() {
    this.isBasicSearchForm = true;
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  mapDataSelected() {
    let data = JSON.parse(localStorage.getItem('signBatchContracts'));
    let index = 1;
    data.forEach(obj => {
      let el = {
        id: obj.id,
        name: obj.nameOrCode,
        createdUser: obj.createdUser,
        status: 2,
        allName: obj.allName,
        allEmail: obj.allEmail,
        receivedTime: obj.receivedTime,
        cStatus: 2,
        contractAttachments: obj.contractAttachments,
        checked: true,
        STT: index,
        uuidContractMoha: obj.uuidContractMoha
      };
      index++;
      this.dataSelected.push(el);
    });
  }

  trimInput(fieldName: string) {
    if (this.documents[fieldName]) {
      this.documents[fieldName] = this.documents[fieldName].trim();
    }
  }

  checkTindy(callback: () => void){
    this.contractService.checkTindyUser().subscribe(ref => {
      if(!ref.success){
        this.toastr.error(ref.message);
        return;
      }
      if(ref.data == 0 || ref.data == 2 ){
         //Popup anthention data
          let message = "";
         if(ref.data == 2){
         message = this.message.getMessage('notifyTindy.notify');
         }else if(ref.data == 0){
         message = this.message.getMessage('notifyTindy.notify_2')
         }
        const confirmDialog = this.dialog.open(WarningDataAuthenticationComponent, {
        width: '469px',
        height: '348px',
        data: {
          message
        }
         });
         confirmDialog.afterClosed().subscribe(ref => {
          if (ref) {
            this.dialog.open(SignAuthenticationPopupComponent, {
            panelClass: 'sign-authentication',
            width: '791px',
            height: 'auto',
            data: {
              message
            }
          });
          }
       });
      }else if(ref.data == 1){
        callback();
      }
    })
  }

}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];
}

export class Document {
  name: string;
  id: string;
  code: string;
  createdTime: string;
  startProcessTime: string;
  finishDate: string;
  createdUser: string;
  customer: string;
  taxCode: string;
  customerTaxCode: string;
  customerCertificateNo: string;
  status: number;
  cStatus: number;
  parentId: string;
  enterprise: string;
  documentType: any;
  type: any;
  email: string;
  checked: boolean;
  typeId: string;
  nameOrCode: string;
  receivedTimeFrom: string;
  receivedTimeTo: string;
  isDifferentEnterprise: boolean;
  isEmploymentContract: boolean;
  contractSource: any;
  uuidContractMoha: string;
}

export class SortKeyPair {
  [key: string]: MatSort;
}

export class BooleanKeyPair {
  [key: string]: boolean;
}

export class StringKeyPair {
  [key: string]: string;
}

export class DocumentKeyPair {
  [key: string]: Document;
}

export class DocumentDataSourceKeyPair {
  [key: string]: DocumentDataSource;
}

export class PaginateKeyPair {
  [key: string]: Paginate;
}

export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  constructor() {
    super();
  }


  setData(data: Document[]) {

    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  disconnect(): void {
    this.data.complete();
  }
}
